import React, { useState } from "react";
import email from "./../../email.svg";

export default function ContactUs() {

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    source: ""
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });

    // clear error on typing
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    let newErrors = {};

    if (!form.name.trim()) {
      newErrors.name = "Name is required";
    }

    // Email optional but validate if filled
    if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!form.phone.trim()) {
      newErrors.phone = "Phone number is required";
    }

    return newErrors;
  };

  const handleSubmit = () => {
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setSuccess("");
      return;
    }

    // Success
    setSuccess("Your message has been sent successfully!");

    // Reset form
    setForm({
      name: "",
      email: "",
      phone: "",
      source: ""
    });

    setErrors({});
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">

      <div className="flex-grow px-4 md:px-8">

        {/* Breadcrumb */}
        <div className="text-xs text-neutral-400 mb-8 mt-2">
          Home <span className="text-zinc-500">/</span>{" "}
          <span className="text-black">Contact Us</span>
        </div>

        {/* Title */}
        <h1 className="text-xl md:text-2xl font-semibold text-black mb-2">
          Get in Touch
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">

          {/* Left Section */}
          <div className="flex flex-col gap-6">

            <p className="text-sm font-semibold text-black">
              Feel free to get in touch with Happenhood today to explore about us.
            </p>

            {/* Form */}
            <div className="flex flex-col gap-4">

              {/* Name */}
              <div>
                {errors.name && (
                  <p className="text-red-500 text-xs mb-1">{errors.name}</p>
                )}
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Name *"
                  className="w-full h-12 px-4 border border-neutral-200 text-sm outline-none"
                />
              </div>

              {/* Email */}
              <div>
                {errors.email && (
                  <p className="text-red-500 text-xs mb-1">{errors.email}</p>
                )}
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="Email"
                  className="w-full h-12 px-4 border border-neutral-200 text-sm outline-none"
                />
              </div>

              {/* Phone */}
              <div>
                {errors.phone && (
                  <p className="text-red-500 text-xs mb-1">{errors.phone}</p>
                )}
                <input
                  type="text"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  placeholder="Phone number *"
                  className="w-full h-12 px-4 border border-neutral-200 text-sm outline-none"
                />
              </div>

              {/* Source */}
              <select
                name="source"
                value={form.source}
                onChange={handleChange}
                className="w-full h-12 px-4 border border-neutral-200 text-sm outline-none"
              >
                <option value="">How did you find us?</option>
                <option>Google</option>
                <option>Facebook</option>
                <option>Friend</option>
                <option>Other</option>
              </select>

              {/* Button */}
              <button
                onClick={handleSubmit}
                className="w-full h-12 bg-green-700 text-white text-sm font-bold uppercase"
              >
                Send
              </button>

              {/* Success Message */}
              {success && (
                <p className="text-green-600 text-sm font-medium">
                  {success}
                </p>
              )}

            </div>

            {/* Contact Info */}
            <div className="flex items-center gap-3">
              <img src={email} alt="email" className="w-7 h-7" />
              <div>
                <p className="text-xs font-semibold">EMAIL</p>
                <p className="text-xs text-rose-500">
                  support@happenhood.com
                </p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}